import styled from 'styled-components';
import { FormHelperText } from '@mui/material';

import colors from '../../styles/colors';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  
  .MuiCheckbox-root {
    color: ${colors.base.primary};
    &.Mui-checked {
      color: ${colors.base.primary};
    }
  }
`;

const StyledFormHelperText = styled(FormHelperText)`
  &.MuiFormHelperText-root {
    color: ${colors.base.primary};
    font-size: 10px;
    line-height: 12px;
    margin: 0;
  }
`;

export {
  Container,
  StyledFormHelperText,
};
